module.exports = __webpack_public_path__ + "static/media/PM7.5e342181.JPG";